<div class="login-container">
  <!-- Left Side - Image -->
  <app-left-ui [welcomeText]="'Forgot Password?'" [welcomeSubtitle]="'Don\'t worry, we\'ll help you reset it.'"></app-left-ui>

  <!-- Right Side - Form -->
  <div class="login-form">
    <div class="form-container text-center">
      <div class="form-header">
        <i class="fa-solid fa-key mb-3" style="color: #bc8710; font-size: 2.5rem; transform: rotate(-45deg);"></i>
        <h2 class="form-title">Forgot Password?</h2>
        <p class="form-subtitle">Don't worry, it happens to the best of us.</p>
      </div>

      <!-- Form starts -->
      <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
        <div class="form-group text-start">
          <label for="usernameOrEmail">Email</label>
          <input
            type="email"
            id="usernameOrEmail"
            name="usernameOrEmail"
            placeholder="Enter your email or username"
            class="form-control"
            [(ngModel)]="forgotModel.usernameOrEmail"
            required
            [disabled]="isLoading"
            #usernameOrEmail="ngModel"
          />
          <div *ngIf="usernameOrEmail.invalid && (usernameOrEmail.dirty || usernameOrEmail.touched)" class="error-message">
            <small *ngIf="usernameOrEmail.errors?.['required']">Email is required.</small>
          </div>
        </div>

        <div class="info-box my-3 p-3 rounded" style="background-color: #f8f9fa; color: #6c757d; font-size: 14px; text-align: left; border: 1px solid #f1f3f5;">
          We'll send you a link to reset your password.
        </div>

        <button
          type="submit"
          class="login-btn pink-btn mt-2"
          [disabled]="loginForm.invalid || isLoading"
        >
          <span *ngIf="!isLoading">
            <i class="fa-regular fa-paper-plane me-2"></i>Send Reset Code
          </span>
          <span *ngIf="isLoading">
            <i class="fa-solid fa-circle-notch fa-spin me-2"></i>Sending...
          </span>
        </button>
      </form>

      <div class="divider">
        <span>or</span>
      </div>
      
      <div class="back-link mt-4">
        <button type="button" class="back-to-login" (click)="navigateToLogin()" [disabled]="isLoading">
          <i class="fa-solid fa-angle-left me-1"></i> Back to Login
        </button>
      </div>
    </div>
  </div>
</div>
